export default class Type {
  constructor(name) {
    this._name = name;
  }

  get name() {
    return this._name;
  }
}
